// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__28Bbh","savePackageButton":"ClientWallet_savePackageButton__1yaGL"};